<template>
    <div class="question">
        <form id="myForm" @submit.prevent>
            <div class="question-item">
                <div class="question-number">
                    {{__t('Запитання')}} <strong>{{ currentQuestion + 1}}</strong> {{__t('з')}} <strong>{{
                    q_length }}</strong>
                </div>
                <div class="question-text">
                    {{ question.title }}
                </div>

                <div class="question-radio">
                    <div class="radio" v-for="qa in question.question_answers">
                        <input type="radio" :id="'q'+qa.id" :name="question.id" :input_name="question.input_name" :value="qa.id" @change="checkRadio">
                        <label :for="'q'+qa.id">{{qa.title}}</label>
                    </div>
                </div>
            </div>
            <a href="javascript:;" class="back-btn" :class="{hidden: currentQuestion == 0}" @click="setPrevQuestion">{{__t('Назад')}}</a>
            <button @click="saveData" :class="{disabled: button_disabled}">
                <span v-if="currentQuestion+1 == q_length">{{__t('Відправити')}}</span>
                <span v-if="currentQuestion+1 != q_length">{{__t('Далі')}}</span>
            </button>
        </form>
    </div>
</template>

<script>

  export default {
    name: 'Radio',
    props: ['q_length', 'question', 'formData', 'currentQuestion'],
    data() {
      return {
        button_disabled: true
      }
    },
    methods: {
      __t(phrase) {
        return window.__t(phrase);
      },
      saveData() {
        let myForm = document.getElementById('myForm');

        let formData = new FormData(myForm);

        var object = {};
        formData.forEach(function (value, key) {
          let input_name = document.getElementsByName(key)[0].getAttribute("input_name");
          object["name"] = input_name
          object["value"] = value;
        });

        object["type"] = this.question.type;

        var rv = {};

        rv[this.question.id] = object;

        if (rv.hasOwnProperty(this.question.id)) {
          this.$emit('saveData', rv)
        }

      },
      checkRadio() {
        let myForm = document.getElementById('myForm');

        let formData = new FormData(myForm);

        var object = {};
        formData.forEach(function (value, key) {
          object[key] = value;
        });

        if (object.hasOwnProperty(this.question.id)) {
          this.button_disabled = false;
        } else {
          this.button_disabled = true;
        }
      },
      setPrevQuestion() {
        this.$emit('setPrevQuestion')
      }
    }
  }

  /*input: event => this.$emit('input', event.target.value)*/
</script>



// WEBPACK FOOTER //
// src/components/type_radio.vue